// @flow
import MenuItemKit from './MenuItemKit';

export default MenuItemKit;
